import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgMiscMcp = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M11.208 2.895a3.483 3.483 0 0 1 4.793.124l.123.129c.715.79 1.002 1.83.86 2.82a3.477 3.477 0 0 1 2.955.984l.042.04a3.474 3.474 0 0 1 .123 4.787l-.124.13-7.122 7.115a.232.232 0 0 0 0 .328l1.463 1.46.047.054a.695.695 0 0 1-.98.978l-.052-.048-1.462-1.46a1.621 1.621 0 0 1 0-2.295l7.121-7.115.144-.159a2.085 2.085 0 0 0 0-2.633l-.143-.159-.04-.04-.16-.143a2.09 2.09 0 0 0-2.636 0l-.16.142-5.947 5.942a.696.696 0 1 1-.985-.983l5.948-5.941.144-.159a2.085 2.085 0 0 0 0-2.633L15.016 4a2.09 2.09 0 0 0-2.794-.142L12.064 4l-7.876 7.867a.696.696 0 1 1-.985-.983l7.876-7.866.13-.124Z"
    />
    <path
      fill="#88827E"
      d="M13.1 4.937a.697.697 0 0 1 .932 1.031l-5.825 5.819a2.085 2.085 0 0 0 0 2.95l.16.143c.82.668 2.03.62 2.794-.143l5.824-5.82a.695.695 0 1 1 .985.984l-5.824 5.819a3.484 3.484 0 0 1-4.793.123l-.13-.123a3.474 3.474 0 0 1 0-4.917l5.825-5.818.053-.048Z"
    />
  </svg>
);
export default SvgMiscMcp;
